import api from "./api";

// Mantenimiento de la puntuacion: la escala, sus detalles
// (puntuaciondetalle), sus grupos (puntuaciongrupo) y el subdetalle de
// cada grupo (puntuaciongrupodetalle).

export const getsPuntuacionView = async () => {
    const response = await api.get("/Puntuacion/GetsPuntuacionView");

    return response.data.data;
}

export const addUpdatePuntuacion = (dataPost) =>
    api.post("/Puntuacion/AddUpdatePuntuacion", dataPost);

export const deletePuntuacion = (idPuntuacion) =>
    api.post("/Puntuacion/DeletePuntuacion?idPuntuacion=" + idPuntuacion);

// ---------- Detalle 1: puntuaciondetalle ----------

export const getsPuntuacionDetalle = async (idPuntuacion) => {
    const response = await api.get("/Puntuacion/GetsPuntuacionDetalle?idPuntuacion=" + idPuntuacion);

    return response.data.data;
}

export const addUpdatePuntuacionDetalle = (dataPost) =>
    api.post("/Puntuacion/AddUpdatePuntuacionDetalle", dataPost);

export const deletePuntuacionDetalle = (idPuntuacionDetalle) =>
    api.post("/Puntuacion/DeletePuntuacionDetalle?idPuntuacionDetalle=" + idPuntuacionDetalle);

// ---------- Detalle 2: puntuaciongrupo ----------

export const getsPuntuacionGrupoPorPuntuacion = async (idPuntuacion) => {
    const response = await api.get("/Puntuacion/GetsPuntuacionGrupoPorPuntuacion?idPuntuacion=" + idPuntuacion);

    return response.data.data;
}

export const getsPuntuacionGrupoDetalle = async (idPuntuacionGrupo) => {
    const response = await api.get("/Puntuacion/GetsPuntuacionGrupoDetalle?idPuntuacionGrupo=" + idPuntuacionGrupo);

    return response.data.data;
}

// El grupo se guarda con su subdetalle completo.
export const addUpdatePuntuacionGrupoWithDetails = (dataPost) =>
    api.post("/Puntuacion/AddUpdatePuntuacionGrupoWithDetails", dataPost);

export const deletePuntuacionGrupo = (idPuntuacionGrupo) =>
    api.post("/Puntuacion/DeletePuntuacionGrupo?idPuntuacionGrupo=" + idPuntuacionGrupo);